/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';

import { createCustomElement, DOMModel, byJsonAttrVal } from '@adobe/react-webcomponent';
import { BrowserRouter } from 'react-router-dom';

import withRoot from '../components/Root/withRoot';
import ProductAdminRoutes from '../components/ProductAdmin/ProductAdminRoutes';
import { browse_root_route, properties_root_route } from '../components/ProductAdmin/urls';

/**
 * Returns the basename of the given pathname, which is everything before either of the product admins root routes or
 * the pathname if the pathname does not contain any of the root routes.
 *
 * @param {string} pathname the path name as it is returned from the window's location object
 */
const BASENAME = (function (pathname) {
    for (let rootRoute of [browse_root_route, properties_root_route]) {
        let idx = pathname.indexOf(rootRoute);
        if (idx == 0) {
            // special case, no basename
            return '/';
        } else if (idx > 0) {
            return pathname.substring(0, idx);
        }
    }
    // fallback to pathname
    return pathname;
})(window.location.pathname);

const Component = () => {
    return (
        <BrowserRouter basename={BASENAME}>
            <ProductAdminRoutes />
        </BrowserRouter>
    );
};

class ProductAdminModel extends DOMModel {
    @byJsonAttrVal() configs;
}

(function () {
    const ProductAdminElement = createCustomElement(withRoot(Component), ProductAdminModel, 'element');

    const elemName = 'product-admin';
    if (!window.customElements.get(elemName)) {
        window.customElements.define(elemName, ProductAdminElement);
    }
})();
